import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Button, Col, Label, Row } from "reactstrap";
import { AvInput, AvField, AvGroup } from 'availity-reactstrap-validation';
import MaterialIcon from "material-icons-react";
import i18n from "../../../../i18next";

import {
    getSurveyPartners,
    getRestaurantSurveyPartnerSettings,
    saveRestaurantSurveyPartnerSettings,
    resetRestaurantSurveyPartnerSettings,
} from '../../../../actions';

class SurveyPartnerScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            settings: {},
            fields: {},
            type: {
                id: '',
                value: '',
                template: ''
            },
            toSaveSurveyPartner: false,
            toResetSurveyPartner: false,
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        this.props.getSurveyPartners()
        if (this.props.restaurantId) {
            this.props.getRestaurantSurveyPartnerSettings(this.props.restaurantId);
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.restaurantId !== this.props.restaurantId) {
            this.props.getRestaurantSurveyPartnerSettings(this.props.restaurantId);
        }

        if (this.props.surveyPartner.restaurantSurveyPartner &&
            prevProps.surveyPartner.restaurantSurveyPartner !== this.props.surveyPartner.restaurantSurveyPartner) {
            this.addSettingsToState(this.props.surveyPartner.restaurantSurveyPartner,
                () => {
                    this.addFieldsToState(this.props.surveyPartner.restaurantSurveyPartner.type.template, true)
                });
        }
    }

    saveSurveyPartnerSettings = () => {
        if (this.state.toSaveSurveyPartner) {
            let data = {
                settings: JSON.stringify(this.state.fields),
                type: {
                    id: this.state.type.id
                }
            };
            this.props.saveRestaurantSurveyPartnerSettings(this.props.restaurantId, data);
            this.setState({
                ...this.state,
                toSaveSurveyPartner: false,
                toResetSurveyPartner: false
            });
        } else if (this.state.toResetSurveyPartner) {
            this.props.resetRestaurantSurveyPartnerSettings(this.props.restaurantId);
            this.setState({
                ...this.state,
                toSaveSurveyPartner: false,
                toResetSurveyPartner: false
            });
        }
    };

    addSettingsToState = (restaurantSurveyPartner, callback) => {
        this.setState({
            ...this.state,
            type: restaurantSurveyPartner.type,
            settings: JSON.parse(restaurantSurveyPartner.settings)
        }, callback);
    };

    selectSurveyPartner = ({ target }) => {
        for (let i = 0; i < this.props.surveyPartner.surveyPartners.length; i++) {

            let surveyPartner = this.props.surveyPartner.surveyPartners[i];

            if (surveyPartner.id === Number(target.value)) {
                this.setState({
                    ...this.state,
                    settings: {},
                    fields: {},
                    type: surveyPartner
                }, () => {
                    this.addFieldsToState(surveyPartner.template, false);
                });
                break;
            }
        }
    };

    addFieldsToState = (template, componentDidMount) => {
        let fieldsWithValue = {};
        this.getFieldsFromString(template).split(",").map((field) => {
            fieldsWithValue = { ...fieldsWithValue, [field]: componentDidMount ? this.state.settings[field] : '' };
        });

        this.setState({
            ...this.state,
            fields: fieldsWithValue,
            toSaveSurveyPartner: !componentDidMount,
            toResetSurveyPartner: false,
        });
    };

    getFieldsFromString(stringOfFields) {
        return stringOfFields.replace(/"/g, "").replace(/\[/g, "").replace(/]/g, "").replace(/ /g, "");
    }

    renderResetButton() {
        return (
            <Button style={{ marginTop: 9 }} color="primary" onClick={this.resetSurveySettings}>
                {i18n.t('common:buttons.reset')}
            </Button>
        );
    };

    resetSurveySettings = () => {
        this.clearPartnerSelection();
    }

    clearPartnerSelection() {
        this.setState({
            ...this.state,
            settings: {},
            fields: {},
            type: {
                id: '',
                value: '',
                template: ''
            },
            toSaveSurveyPartner: false,
            toResetSurveyPartner: true

        });
    }

    renderSurveyPartnerSelect() {
        const { fieldContainer, inputGroupStyle, labelStyle, inputStyle } = styles;

        return (
            <div style={fieldContainer}>
                <AvGroup style={inputGroupStyle}>
                    <Label style={labelStyle}>{i18n.t('screens:surveyPartnerScreen.partner')}</Label>
                    <AvGroup style={inputStyle}>
                        <AvField type="select" name="id" id="surveyPartner"
                            value={this.state.type.id}
                            onChange={this.selectSurveyPartner}
                        >
                            <option disabled value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
                            {this.props.surveyPartner.surveyPartners.map((item, i) => {
                                return (<option value={item.id} id={item.id} key={i}>{item.value}</option>)
                            })}
                        </AvField>
                    </AvGroup>
                </AvGroup>
                {this.renderResetButton()}
                {this.state.toSaveSurveyPartner || this.state.toResetSurveyPartner ? this.renderSaveReminder() : null}
            </div>
        )
    }

    updateFieldValue = ({ target }) => {
        this.setState({
            ...this.state,
            toSaveSurveyPartner: true,
            fields: {
                ...this.state.fields,
                [target.name]: target.value
            }
        });
    };

    renderSurveyPartnerFields() {
        const { inputGroupStyle, labelStyle, inputStyle, fieldContainer } = styles;
        return (
            <div style={fieldContainer}>
                {Object.keys(this.state.fields).map((key) => {
                    return (
                        <AvGroup style={inputGroupStyle}>
                            <Label style={labelStyle}>{i18n.t(`screens:surveyPartnerScreen.fields.${key}`)}</Label>
                            <AvInput style={inputStyle}
                                type={key === 'password' ? 'password' : 'text'} name={key}
                                value={this.state.fields[key]}
                                onChange={this.updateFieldValue}
                                errorMessage={i18n.t('common:validations.errorMsg')}
                                required>
                            </AvInput>
                            {/* <AvFeedback>
                            {i18n.t('common:validations.errorMsg')}
                            </AvFeedback> */}
                        </AvGroup>
                    )
                })}
            </div>
        );
    }

    renderSaveReminder() {
        const { reminderText } = styles;
        return (
            <p style={reminderText}>{i18n.t('common:validations.saveWarningMsg')}</p>
        );
    }

    render() {
        const { headerStyle, headerTitle, hint } = styles;

        return (
            <Fragment>
                <Col className="sectionStyle">
                    <Row>
                        <div style={headerStyle}>
                            <MaterialIcon icon="feedback" size={20} color='#0288d1' />
                            <span style={headerTitle}>{i18n.t('screens:surveyPartnerScreen.heading')}</span>
                        </div>
                    </Row>
                    <Row>
                        <div style={{ width: '100%' }}>
                            {this.renderSurveyPartnerSelect()}
                            {this.renderSurveyPartnerFields()}
                            {/* <p style={hint}>{i18n.t(`screens:deliveryPartnerScreen.hint`)}</p> */}
                        </div>
                    </Row>
                </Col>
            </Fragment >
        );
    }
}

const mapStateToProps = state => {
    return {
        surveyPartner: state.surveyPartner,
        restaurantId: state.restaurant.id,
    }
}

export default connect(mapStateToProps, { getSurveyPartners, getRestaurantSurveyPartnerSettings, saveRestaurantSurveyPartnerSettings, resetRestaurantSurveyPartnerSettings })(SurveyPartnerScreen);

const styles = {
    headerStyle: {
        paddingLeft: 0,
        paddingRight: 0,
        borderBottom: "1px solid rgb(222, 226, 230)",
        width: 400
    },
    headerTitle: {
        paddingLeft: 4,
        color: '#0288d1'
    },
    inputGroupStyle: {
        width: '50%',
        padding: "10px 20px 0 20px",
        display: 'flex',
        justifyContent: 'space-between'
    },
    labelStyle: {
        width: '30%',
        paddingTop: 10
    },
    inputStyle: {
        width: '60%'
    },
    fieldContainer: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    hint: {
        fontSize: 14
    },
    reminderText: {
        color: '#dc3545',
        fontSize: 13,
        position: 'absolute',
        right: 20,
        paddingTop: 20
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/SurveyPartnerScreen.js